export type ApiErrorCode =
  | "unauthorized"
  | "forbidden"
  | "not_found"
  | "validation_error"
  | "conflict"
  | "refine_in_progress"
  | "package_not_refinable"
  | "no_candidate"
  | "not_completed"
  | "review_not_postable"
  | "review_count_out_of_range"
  | "invalid_params"
  | "route_not_found"
  | "feature_disabled"
  | "form_not_found"
  | "rate_limited"
  | "server_error";

export interface ApiError {
  error: ApiErrorCode;
  message: string;
  details?: Record<string, unknown>;
}

/**
 * True when `e` is the design endpoints' error envelope (a string `error` code), and when `code`
 * is given, only when it matches. Network failures arrive as `{ message }` without `error`.
 */
export function isApiError(e: unknown, code?: ApiErrorCode): e is ApiError {
  if (!e || typeof e !== "object") return false;
  const error = (e as { error?: unknown }).error;
  if (typeof error !== "string") return false;
  return code === undefined || error === code;
}

export function apiErrorMessage(e: unknown, fallback: string): string {
  if (typeof e === "string" && e.trim().length > 0) return e;
  if (e && typeof e === "object") {
    const message = (e as { message?: unknown }).message;
    if (typeof message === "string" && message.trim().length > 0) return message;
  }
  return fallback;
}
